import { getOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGet } from '@/common/api/client/sdk.gen'
import { useQuery } from '@tanstack/react-query'

export const useBalance = (org_id: string | undefined) => {
    const { data, isLoading, isPending, error } = useQuery({
        queryKey: ['balance', org_id],
        queryFn: () =>
            org_id
                ? getOrganizationTokenBalanceApiV1BillingOrgIdBillingBalanceGet({ path: { org_id } }).then(r => r.data!)
                : Promise.reject('No org_id'),
        enabled: !!org_id,
        refetchInterval: 30000,
    })
    return { data, isLoading, isPending, error }
}
